import React from "react";
import { Switch, Route } from "react-router-dom";
// import { TimeTask } from "../views/home/timeTask";
import DataCatalog from "../views/masterDataList/dataCatalog/view";
import CataLogDetail from "../views/masterDataList/dataCatalog/view/CataLogDetail";
import CataLogAdd from "../views/masterDataList/dataCatalog/view/CataLogAdd";


import DataBranch from "../views/masterDataList/dataBranch/view";
import BranchDetail from "../views/masterDataList/dataBranch/view/branchDetail"
import DataJournal from "../views/masterDataList/dataJournal/view";
import JournalDetail from "../views/masterDataList/dataJournal/view/journalDetail";

import DataHistory from "../views/masterDataList/dataHistory/view";
import HistoryDetail from "../views/masterDataList/dataHistory/view/historyDetail";

import MdDict from "../views/masterDataService/dict/view"; //字典

import Warehouse from "../views/masterDataService/warehouse/view"; //仓库管理
import WarehouseDetail from "../views/masterDataService/warehouse/view/warehouseDetail"; //仓库详情

import Organization from "../views/masterDataService/organization/view"
import MaterielType from "../views/masterDataService/materielType/view"//物料类型
import Materiel from "../views/masterDataService/materiel/view"//物料管理
import MaterielDetail from "../views/masterDataService/materiel/view/materielDetail"//物料管理详情

import Customer from "../views/masterDataService/customer/view"//客户管理
import CustomerDetail from "../views/masterDataService/customer/view/customerDetail"//客户管理详情
import User from "../views/masterDataService/user/view"//用户管理
import UserDetail from "../views/masterDataService/user/view/userDetail"//用户管理详情

import Config from "../views/masterDataService/config/view"//配置管理
import ConfigDetail from "../views/masterDataService/config/view/configDetail"//配置管理详情
import Apply from "../views/masterDataService/apply/view"//配置管理
import ApplyDetail from "../views/masterDataService/apply/view/applyDetail"//配置管理详情
import ServiceItems from "../views/masterDataService/serviceItems/view"//服务项目管理
import ServiceItemsDetail from "../views/masterDataService/serviceItems/view/serviceItemsDetail"//服务项目管理
import Entity from "../views/masterDataService/entity/view"//经营实体管理
import EntityDetail from "../views/masterDataService/entity/view/entityDetail"//经营实体管理详情
import Supplier from "../views/masterDataService/supplier/view" //供应商类型
import SuppliergDetail from "../views/masterDataService/supplier/view/supplierDetail" //供应商类型详情
import Vehicle from "../views/masterDataService/vehicle/view"//车辆管理
import VehicleDetail from "../views/masterDataService/vehicle/view/vehicleDetail"//车辆管理详情

import { OrganizaShop } from "../views/masterDataService/shop/view";  //机构管理
import { Prompt } from "../views/masterDataService/prompt/view"; 
import { BaseAcctUnit } from "../views/masterDataService/acctUnit/view";
import ServiceItemsShopDetails from "@/views/masterDataService/serviceItems/view/serviceItemsShopDetails";
const FmsRoute = (): JSX.Element => {
    return (
        <Switch>
            <Route exact={true} path={"/"} component={DataCatalog} />
            <Route exact={true} path={"/data/catalog/insert"} component={CataLogAdd} />
            <Route exact={true} path={"/data/catalog/edit"} key="/data/catalog/edit" component={CataLogDetail} />
            <Route exact={true} path={"/data/catalog/look"} key="/data/catalog/look" component={CataLogDetail} />

            <Route exact={true} path={"/data/branch"} component={DataBranch} />
            <Route exact={true} path={"/data/branch/insert"} key="/data/branch/insert" component={BranchDetail} />
            <Route exact={true} path={"/data/branch/edit"} key="/data/branch/edit" component={BranchDetail} />
            <Route exact={true} path={"/data/branch/look"} key="/data/branch/look" component={BranchDetail} />
            <Route exact={true} path={"/data/journal"} component={DataJournal} />
            <Route exact={true} path={"/data/journal/look"} key="/data/journal/look" component={JournalDetail} />
            <Route exact={true} path={"/data/history"} component={DataHistory} />
            <Route exact={true} path={"/data/history/look"} key="/data/history/look" component={HistoryDetail} />

            <Route exact={true} path={"/dataService/dict"} key="/dataService/dict" component={MdDict} />

            <Route exact={true} path={"/dataService/warehouse"} key="/dataService/warehouse" component={Warehouse} />
            <Route exact={true} path={"/dataService/warehouse/insert"} key="/dataService/warehouse/insert" component={WarehouseDetail} />
            <Route exact={true} path={"/dataService/warehouse/edit"} key="/dataService/warehouse/edit" component={WarehouseDetail} />
            <Route exact={true} path={"/dataService/warehouse/look"} key="/dataService/warehouse/look" component={WarehouseDetail} />
            {/* 组织机构 */}
            <Route exact={true} path={"/dataService/organization"} key="/dataService/organization" component={Organization} />

            {/* 物料类型管理 */}
            <Route exact={true} path={"/dataService/materielType"} key="/dataService/materielType" component={MaterielType} />
            {/* 物料管理 */}
            <Route exact={true} path={"/dataService/materiel"} key="/dataService/materiel" component={Materiel} />
            <Route exact={true} path={"/dataService/materiel/insert"} key="/dataService/materiel/insert" component={MaterielDetail} />
            <Route exact={true} path={"/dataService/materiel/edit"} key="/dataService/materiel/edit" component={MaterielDetail} />
            <Route exact={true} path={"/dataService/materiel/look"} key="/dataService/materiel/look" component={MaterielDetail} />
            {/* 客户管理 */}
            <Route exact={true} path={"/dataService/customer"} key="/dataService/customer" component={Customer} />
            <Route exact={true} path={"/dataService/customer/insert"} key="/dataService/customer/insert" component={CustomerDetail} />
            <Route exact={true} path={"/dataService/customer/edit"} key="/dataService/customer/edit" component={CustomerDetail} />
            <Route exact={true} path={"/dataService/customer/look"} key="/dataService/customer/look" component={CustomerDetail} />
            {/* 用户管理 */}
            <Route exact={true} path={"/dataService/user"} key="/dataService/user" component={User} />
            <Route exact={true} path={"/dataService/user/insert"} key="/dataService/user/insert" component={UserDetail} />
            <Route exact={true} path={"/dataService/user/edit"} key="/dataService/user/edit" component={UserDetail} />
            <Route exact={true} path={"/dataService/user/look"} key="/dataService/user/look" component={UserDetail} />
            {/* 配置管理 */}
            <Route exact={true} path={"/dataService/config"} key="/dataService/config" component={Config} />
            <Route exact={true} path={"/dataService/config/insert"} key="/dataService/config/insert" component={ConfigDetail} />
            <Route exact={true} path={"/dataService/config/edit"} key="/dataService/config/edit" component={ConfigDetail} />
            <Route exact={true} path={"/dataService/config/look"} key="/dataService/config/look" component={ConfigDetail} />
            {/* 应用管理 */}
            <Route exact={true} path={"/dataService/apply"} key="/dataService/apply" component={Apply} />
            <Route exact={true} path={"/dataService/apply/insert"} key="/dataService/apply/insert" component={ApplyDetail} />
            <Route exact={true} path={"/dataService/apply/edit"} key="/dataService/apply/edit" component={ApplyDetail} />
            <Route exact={true} path={"/dataService/apply/look"} key="/dataService/apply/look" component={ApplyDetail} />
            {/* 服务项目管理 */}
            <Route exact={true} path={"/dataService/serviceItems"} key="/dataService/serviceItems" component={ServiceItems} />
            <Route exact={true} path={"/dataService/serviceItems/insert"} key="/dataService/serviceItems/insert" component={ServiceItemsDetail} />
            <Route exact={true} path={"/dataService/serviceItems/edit"} key="/dataService/serviceItems/edit" component={ServiceItemsDetail} />
            <Route exact={true} path={"/dataService/serviceItems/look"} key="/dataService/serviceItems/look" component={ServiceItemsDetail} />
            <Route exact={true} path={"/dataService/serviceItems/shopDetail"} key="/dataService/serviceItems/shopDetail" component={ServiceItemsShopDetails} />


            {/* 经营实体管理 */}
            <Route exact={true} path={"/dataService/entity"} key="/dataService/entity" component={Entity} />
            <Route exact={true} path={"/dataService/entity/insert"} key="/dataService/entity/insert" component={EntityDetail} />
            <Route exact={true} path={"/dataService/entity/edit"} key="/dataService/entity/edit" component={EntityDetail} />
            <Route exact={true} path={"/dataService/entity/look"} key="/dataService/entity/look" component={EntityDetail} />
            {/* 供应商管理 */}
            <Route exact={true} path={"/dataService/supplier"} key="/dataService/supplier" component={Supplier} />
            <Route exact={true} path={"/dataService/supplier/insert"} key="/dataService/supplier/insert" component={SuppliergDetail} />
            <Route exact={true} path={"/dataService/supplier/edit"} key="/dataService/supplier/edit" component={SuppliergDetail} />
            <Route exact={true} path={"/dataService/supplier/look"} key="/dataService/supplier/look" component={SuppliergDetail} />
            {/* 车辆管理 */}
            <Route exact={true} path={"/dataService/vehicle"} key="/dataService/vehicle" component={Vehicle} />
            <Route exact={true} path={"/dataService/vehicle/insert"} key="/dataService/vehicle/insert" component={VehicleDetail} />
            <Route exact={true} path={"/dataService/vehicle/edit"} key="/dataService/vehicle/edit" component={VehicleDetail} />
            <Route exact={true} path={"/dataService/vehicle/look"} key="/dataService/vehicle/look" component={VehicleDetail} />
            {/*门店管理 */}
            <Route exact={true} path={"/dataService/shop"} key="2-14" component={OrganizaShop} />
            {/* 错误日志 */}
            <Route exact={true} path={"/dataService/prompt"} key="2-14" component={Prompt} />
            {/* 内部核算单位 */}
            <Route exact={true} path={"/base/acctUnit"} key="2-15" component={BaseAcctUnit} />
        </Switch>
    )
}

export default FmsRoute;
